<template>
  <div id="MenuItem">
    <router-link
      :to="to ? to : ''"
      class="menu-item"
      active-class="active"
      @click.native="refreshPage(to)"
    >
      <img :src="icon" class="menu-icon" />
      <span class="title">{{ title }}</span>
    </router-link>
  </div>
</template>
<style lang="scss" scoped>
@import "../assets/scss/variable";

#MenuItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  .menu-item {
    width: 95px;
    height: 95px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    transition: all 0.3s;
    border-radius: 10px;
    box-sizing: border-box;
    color: #333333;

    &:hover {
      box-shadow: 0px 0px 5.2px 3px #2e7afd33;
    }

    .menu-icon {
      width: 42px;
      height: 42px;
      margin-bottom: 10px;
    }
  }

  .active {
    box-shadow: 0px 0px 5.2px 3px #2e7afd33;
  }
}
</style>
<script>
export default {
  props: {
    icon: String,
    title: String,
    to: [String, Object],
  },
  methods: {
    refreshPage(path) {
      if (path === this.$route.path) {
        this.$router.go(0);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// MenuItem.vue?951ab5f8